(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["shipping-timer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shipping-timer')) {
    class ShippingTimer extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.locale = document.documentElement.lang || 'tr-TR';
        this.timeZone = this.dataset.timeZone || 'Europe/Istanbul';
        this.cutoffHour = Number(this.dataset.cutoffHour || 11);
        this.renderTimer();
        this.interval = window.setInterval(() => this.renderTimer(), 15000);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      getTurkeyParts(date) {
        const values = {};
        new Intl.DateTimeFormat('en-CA', {
          timeZone: this.timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        }).formatToParts(date).forEach((part) => {
          if (part.type !== 'literal') values[part.type] = Number(part.value);
        });
        return values;
      }

      dateOnly(year, month, day) {
        return new Date(Date.UTC(year, month - 1, day, 12));
      }

      addDays(date, amount) {
        const copy = new Date(date);
        copy.setUTCDate(copy.getUTCDate() + amount);
        return copy;
      }

      addWorkingDays(date, amount) {
        let result = new Date(date);
        let addedDays = 0;

        while (addedDays < amount) {
          result = this.addDays(result, 1);
          if (result.getUTCDay() !== 0) {
            addedDays += 1;
          }
        }

        return result;
      }

      dateKey(date) {
        return `${date.getUTCFullYear()}-${date.getUTCMonth()}-${date.getUTCDate()}`;
      }

      formatDate(date) {
        return new Intl.DateTimeFormat(this.locale, {
          day: 'numeric',
          month: 'long',
          timeZone: 'UTC'
        }).format(date);
      }

      shippingDayLabel(today, shippingDay) {
        const tomorrow = this.addDays(today, 1);
        if (this.dateKey(today) === this.dateKey(shippingDay)) return this.dataset.today;
        if (this.dateKey(tomorrow) === this.dateKey(shippingDay)) return this.dataset.tomorrow;
        return new Intl.DateTimeFormat(this.locale, {
          weekday: 'long',
          timeZone: 'UTC'
        }).format(shippingDay);
      }

      getSchedule(now) {
        const parts = this.getTurkeyParts(now);
        const today = this.dateOnly(parts.year, parts.month, parts.day);
        const isSunday = today.getUTCDay() === 0;
        const beforeCutoff = parts.hour < this.cutoffHour;
        let shippingDay = today;

        if (isSunday || !beforeCutoff) {
          shippingDay = this.addDays(today, 1);
          while (shippingDay.getUTCDay() === 0) {
            shippingDay = this.addDays(shippingDay, 1);
          }
        }

        const cutoffUtcHour = this.cutoffHour - 3;
        const cutoffAt = new Date(Date.UTC(
          shippingDay.getUTCFullYear(),
          shippingDay.getUTCMonth(),
          shippingDay.getUTCDate(),
          cutoffUtcHour,
          0,
          0
        ));

        return {
          today,
          shippingDay,
          cutoffAt,
          deliveryStart: this.addWorkingDays(shippingDay, 1),
          deliveryEnd: this.addWorkingDays(shippingDay, 3)
        };
      }

      formatRemaining(milliseconds) {
        const totalMinutes = Math.max(1, Math.ceil(milliseconds / 60000));
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        if (hours === 0) return `${minutes} ${this.dataset.minute}`;
        if (minutes === 0) return `${hours} ${this.dataset.hour}`;
        return `${hours} ${this.dataset.hour} ${minutes} ${this.dataset.minute}`;
      }

      fill(template, replacements) {
        return Object.entries(replacements).reduce(
          (result, [key, value]) => result.replaceAll(`__${key.toUpperCase()}__`, value),
          template
        );
      }

      renderTimer() {
        const now = new Date();
        const schedule = this.getSchedule(now);
        const remaining = this.formatRemaining(schedule.cutoffAt.getTime() - now.getTime());
        const shippingLabel = this.shippingDayLabel(schedule.today, schedule.shippingDay);
        const countdown = this.fill(this.dataset.countdownTemplate, {
          time: `<strong>${remaining}</strong>`,
          shipping_day: `<strong>${shippingLabel}</strong>`
        });

        this.querySelector('[data-countdown]').innerHTML = countdown;
        this.querySelector('[data-order-date]').textContent = this.fill(this.dataset.orderTemplate, {
          date: this.formatDate(schedule.today)
        });
        this.querySelector('[data-shipping-date]').textContent = this.fill(this.dataset.shippingTemplate, {
          date: this.formatDate(schedule.shippingDay)
        });
        this.querySelector('[data-delivery-date]').textContent = this.fill(this.dataset.deliveryTemplate, {
          date: `${this.formatDate(schedule.deliveryStart)}–${this.formatDate(schedule.deliveryEnd)}`
        });
      }
    }

    customElements.define('shipping-timer', ShippingTimer);
  }
  } catch(e) { console.error(e); }
})();

})();
